import type {
    AudioMuteHandler,
    HostIntegration,
    PlayerAuthenticationResult,
    PlayerCredentialResult,
    RoomLaunchIntent,
} from "./types";

class NoopHostIntegration implements HostIntegration {
    initialize(): Promise<void> {
        return Promise.resolve();
    }

    getPlayerCredential(): Promise<PlayerCredentialResult> {
        return Promise.resolve({
            status: "unavailable",
            credential: null,
        });
    }

    requestPlayerAuthentication(): Promise<PlayerAuthenticationResult> {
        return Promise.resolve("not-authenticated");
    }

    onPlayerAuthenticated(): () => void {
        return () => undefined;
    }

    syncGameStatus(): void {
        return undefined;
    }

    syncRoom(): void {
        return undefined;
    }

    consumeRoomLaunchIntent(): RoomLaunchIntent {
        return { type: "none" };
    }

    onRoomJoinRequested(): () => void {
        return () => undefined;
    }

    onAudioMuteChanged(handler: AudioMuteHandler): () => void {
        handler(false);

        return () => undefined;
    }

    createRoomInviteUrl(): string | null {
        return null;
    }
}

export default NoopHostIntegration;
